import ErrorFallback from 'Components/ErrorFallback'
import {
  DeviceCreatePage,
  DeviceEditPage,
  DeviceListPage
} from 'Services/ServiceProviderManagement/Features/Device/Pages'
import { ErrorBoundary } from 'react-error-boundary'
import { Route, Routes } from 'react-router-dom'

function DeviceRoot() {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Routes>
        <Route index element={<DeviceListPage />} />
        <Route path="create" element={<DeviceCreatePage />} />
        <Route path=":pta/:id/edit" element={<DeviceEditPage />} />
      </Routes>
    </ErrorBoundary>
  )
}

export default DeviceRoot
